
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.46 1.88L3.61 3.55a.33.33 0 00-.11.25v1a.18.18 0 00.17.2h1a.32.32 0 00.23-.09l1.8-1.66A3 3 0 015.5 7.1v5.4a1.5 1.5 0 01-3 0V7.1a3 3 0 013-5.22zm2.37 3.77h1.41a1.77 1.77 0 011.5.84l1.07 1.75a.85.85 0 00.6.41l1.9.32a.87.87 0 01.73.82l.1 1.88a.87.87 0 01-.83.92H14a1.52 1.52 0 01-1.44 1.05 1.55 1.55 0 01-1.42-1H6.47V8.48h4a.22.22 0 00.22-.22.2.2 0 000-.11l-.96-1.54a.44.44 0 00-.38-.21H7.52a4.09 4.09 0 00.31-.75zm4.76 7.09a.67.67 0 00.66-.68.68.68 0 00-.66-.68.68.68 0 000 1.36zM4 12.5a.5.5 0 10-.5-.5.5.5 0 00.5.5z"}})])
          )
        }
      }
    